import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Desktop } from "../containers/common";

const Front = () => {
  const history = useHistory();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn) {
      history.push("/home");
    }
  }, []);

  return (<Desktop phonebg={"white"} />);
};

export default Front;
